import { Button as MUIButton } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

export const CustomButton = withStyles({
  root: {
    textTransform: 'initial',
    background: '#00A1FF',
    color: '#fff',
    marginRight: 16,
    padding: 3,
    borderRadius: 10,
  },
  label: {
    border: '2px solid #404344',
    padding: '8px 12px',
    borderRadius: 8,
  },
})(MUIButton);
